module.exports = __webpack_public_path__ + "img/63a762c.jpg";